var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('FlashMessage',{attrs:{"position":"right top"}}),_c('MyTitleApp'),_c('Message',{directives:[{name:"show",rawName:"v-show",value:(_vm.msg),expression:"msg"}],attrs:{"msg":_vm.msg}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }